import React from "react";

import { trDts } from "@modules/datasheets/utils/i18n";

import {
  DatasheetTabNameManagementProps,
  DatasheetTabNameManagementMode,
  DatasheetTabNameManagementConfig,
} from "./tab-name-management.types";
import { useMessage } from "@common/hooks/message";

export const useController = (props: DatasheetTabNameManagementProps) => {
  const { onSubmit, mode } = props;

  const { closeMessage, showConfirmMessage, showErrorMessage, messageProps } = useMessage();

  const [tabName, setTabName] = React.useState<string>("");

  const handleFormatNameChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setTabName(e.target.value);
  }, []);

  const isAllowedToSubmit = React.useCallback(
    (params: { tabName: string }) => Boolean(params.tabName.trim().length),
    []
  );

  const config: Record<DatasheetTabNameManagementMode, DatasheetTabNameManagementConfig> = {
    [DatasheetTabNameManagementMode.add]: {
      title: trDts("Add a tab to the datasheet"),
    },
    [DatasheetTabNameManagementMode.rename]: {
      title: trDts("Rename tab"),
    },
    [DatasheetTabNameManagementMode.paste]: {
      title: trDts("Copy tab"),
    },
  };

  const handleTabSubmit = React.useCallback(() => {
    onSubmit({ tabName });
  }, [onSubmit, tabName]);

  return {
    tabName,
    modeConfig: config[mode],
    messageProps,
    closeMessage,
    handleTabSubmit,
    showErrorMessage,
    isAllowedToSubmit,
    showConfirmMessage,
    handleFormatNameChange,
  };
};
